import { createIcon } from '../createIcon.tsx';

export const BedIcon = createIcon(
	'BedIcon',
	<>
		<path d="M3 20V6" />
		<path d="M21 20v-5a2 2 0 0 0-2-2H3" />
		<path d="M3 14h18" />
		<circle cx="7" cy="10" r="1.6" />
		<path d="M11 13V9a2 2 0 0 1 2-2h4" />
	</>,
);
